import React from "react";
import Sidebar from "@/components/Sidebar";
import NotificationsHub from "@/components/NotificationsHub";
import NewsBanner from "@/components/NewsBanner";
import PaywallBanner from "@/components/PaywallBanner";
import TelegramJoinPopup from "@/components/TelegramJoinPopup";
import { useSSE } from "@/hooks/useSSE";

/** SSEContext lifts the SSE connection so all child routes share one stream. */
export const SSEContext = React.createContext({
  tickMap: {}, status: "connecting", lastEvent: null, lastLifecycle: null,
  lastNewsAlert: null, lastAdminActivity: null,
});

export default function AppShell({ children }) {
  const sse = useSSE();
  return (
    <SSEContext.Provider value={sse}>
      <div className="min-h-screen bg-ink-900 text-white">
        <Sidebar sseStatus={sse.status} />
        <main className="ml-64 min-h-screen">
          <PaywallBanner />
          <NewsBanner />
          {children}
        </main>
        <NotificationsHub />
        <TelegramJoinPopup />
      </div>
    </SSEContext.Provider>
  );
}
